// TextInput.tsx

import React from 'react'
import './Button.scss'
import Loading from 'icons/loading.svg'
interface ButtonProps {
  label: string
  loading?: boolean
  onClick: React.MouseEventHandler<HTMLButtonElement>
  fullWidth?: boolean
}

export const Button: React.FC<ButtonProps> = ({
  label,
  onClick,
  loading,
  fullWidth = true,
}) => {
  return (
    <div className="button">
      <button
        className={`button__input ${
          fullWidth ? 'button__input--full-width' : ''
        }`}
        onClick={(e) => {
          e.preventDefault()
          e.stopPropagation()
          onClick(e)
        }}
        disabled={loading}
      >
        {loading ? <img src={Loading} alt="My SVG" height={30} /> : `${label}`}
      </button>
    </div>
  )
}
